var MANAGE = {
  HEAD_ORG_ID: '100001',
  // 总行部门id
  TOP_ORG_ID: '100000' // 橙子银行
};

export default MANAGE;